import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import List from "Components/List/List";
import FlexRow from "Components/FlexRow";
import DotsIcon from "Assets/SVG/DotsIcon";
import {IFoilTypeDto} from "Apis/Models/IPrintDto";

interface IProps {
    foilTypes?: IFoilTypeDto[];
    isLoading: boolean;
}
const FoilTypeList = (props: IProps) => {
    
    const { t } = useTranslation();
    
    const { foilTypes, isLoading } = props;
    
    const navigate = useNavigate();
    
    return (
        <List<IFoilTypeDto> data={foilTypes} loading={isLoading} columns={[
            {
                title: t('name'),
                textRender: (record) => record.name
            },
            {
                title: t('functions'),
                size: "min-content",
                customRender: (record) => <FlexRow className={"h-100 clickable"} justify={"center"} onClick={() => navigate(`/prints/foilType/edit/${record.id}`)} ><DotsIcon /></FlexRow>
            }
        ]} keyExtractor={(record) => record.id.toString()} />
    )
}

export default FoilTypeList
